import React from 'react';

import { IconDollarSign, IconMusicNotes } from '@trqk/components';
import { addThousandsSeparator, formatDollarsKpi } from '@trqk/utils';

import { PerformanceCharts, PerformanceData } from '.';
import { KPI, WorkDetailCard, WorkDetailSection } from '..';
import { getFeatureFlags } from '../../../../../featureFlags';

interface PerformancesProps {
    /**
     * A label including the PRO and time period
     */
    periodLabel: string;
    /**
     * The PRO name
     */
    pro: string;
    /**
     * A timestamp indicating that the PerformanceContributionsTable data should be refreshed
     */
    refreshTable: number;
    /**
     * Total earnings in the merged work data
     */
    total_earnings: number;
    /**
     * Total performances in the merged work data
     */
    totalPerformances: number;
    /**
     * The merged ProTrack data containing the performance contributions to be rendered in the
     * PerformanceContributionsTable
     */
    trackData: ProTrack | null;
}

export const Performances = ({
    periodLabel,
    pro,
    refreshTable,
    total_earnings,
    totalPerformances,
    trackData,
}: PerformancesProps): JSX.Element => {
    const { truncateChartData } = getFeatureFlags();

    return (
        <>
            <WorkDetailSection>
                <div className="w-2/3 grid grid-cols-2 gap-4">
                    <KPI
                        bgClass="bg-secondary-500"
                        Icon={IconDollarSign}
                        label={`${pro} Reported Earnings`}
                        value={formatDollarsKpi(total_earnings)}
                    />
                    <KPI
                        bgClass="bg-quarternary-500"
                        Icon={IconMusicNotes}
                        label={`${pro} Reported Plays`}
                        value={addThousandsSeparator(totalPerformances)}
                    />
                </div>
            </WorkDetailSection>
            <WorkDetailSection>
                <div className="grid grid-cols-2 gap-4">
                    <WorkDetailCard>
                        {trackData !== null && (
                            <PerformanceData
                                periodLabel={periodLabel}
                                refreshTable={refreshTable}
                                trackData={trackData}
                                truncateChartData={truncateChartData}
                            />
                        )}
                    </WorkDetailCard>
                    <WorkDetailCard>
                        {trackData && (
                            <PerformanceCharts
                                trackData={trackData}
                                truncateChartData={truncateChartData}
                            />
                        )}
                    </WorkDetailCard>
                </div>
            </WorkDetailSection>
        </>
    );
};
